import { combineReducers } from 'redux';
import reports from './reports';
import insights from './insights';
import user from './user';
import { courses } from './courses';

const rootReducer = combineReducers({
  reports,
  insights,
  user,
  courses,
});

export default rootReducer;
